export default "__VITE_ASSET__Doui81dJ__"